import { Badge } from '@chakra-ui/react'

type Props = {
  label: string
  count: number
}

export function QueueCountBadge({ label, count }: Props) {
  return (
    <Badge
      variant="outline"
      borderRadius="md"
      borderColor="blue.500"
      color="blue.600"
      px={3}
      py={1}
      fontWeight="600"
    >
      {label} : {count}
    </Badge>
  )
}
